import { render, staticRenderFns } from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=template&id=7f3b50ad&scoped=true"
import script from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=script&lang=js"
import style0 from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=style&index=0&id=7f3b50ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3b50ad",
  null
  
)

export default component.exports